<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Meta Info</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  id="meta_info_page"
                  label="Meta Page"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Page"
                  v-model.trim="metaInfoDataNew.meta_info_page"
                  @change="handleMetaInfoPage"
                  :readonly="readonly"
              />
              Contoh jika url: https://lionparcel.com/product yang di input adalah /product.
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Title"
                  class="mb-0"
                  type="text"
                  required
                  horizontal
                  placeholder="Title"
                  v-model.trim="metaInfoDataNew.meta_info_title"
                  @change="handleMetaInfoTitle"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8" >
              <CTextarea
                  label="Meta Description"
                  class="mb-0"
                  type="text"
                  @input="handleMetaInfoDescription"
                  required
                  horizontal
                  v-model.trim="metaInfoDataNew.meta_info_description"
                  placeholder="Meta Description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8" >
              <CTextarea
                  label="Meta Keyword"
                  class="mb-0"
                  type="text"
                  @input="handleMetaInfoKeyword"
                  required
                  horizontal
                  v-model.trim="metaInfoDataNew.meta_info_keyword"
                  placeholder="Meta Keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Ilustrasi di perlukan
              </div>
              <CInputFile
                  label="Foto Ilustrasi"
                  horizontal
                  type="file"
                  @change="handleMetaInfoPhotoUrl"
              />
              File size should be below 250KB.
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="url" :src="url" />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                  label="Meta Publish Date"
                  class="mb-0"
                  type="date"
                  required
                  horizontal
                  placeholder="Publish Date"
                  v-model.trim="metaInfoDataNew.publish_date"
                  @change="handleMetaInfoPublishDate"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  @click="updateMetaInfo"
              >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";

export default {
  name: "MetaInfoEdit",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      metaInfoDataNew: {},
      imageIs: "ADA",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      url: null,
      readonly:false,
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  computed: {},
  methods: {
    getDataByID() {
      let MetaInfoID = this.$route.params.id;
      axios
          .get(`${this.domain}/v1/meta_info/data/${MetaInfoID}`, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            this.metaInfoDataNew = response.data;
            if(this.metaInfoDataNew.meta_info_page == 'default'){
              this.readonly=true
            }
            this.metaInfoDataNew.publish_date = moment(this.metaInfoDataNew.meta_info_publish_time).format("YYYY-MM-DD");
            this.url = this.metaInfoDataNew.attachment_meta_info_photo_url;
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?err.response.data.message.id:'Something Went Wrong'
            });
          });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({ path: "/management/meta-info" });
    },
    handleMetaInfoPage(value) {
      this.checkDuplicate(value);
    },
    handleMetaInfoTitle(value) {
      this.metaInfoDataNew.meta_info_title = value;
    },
    handleMetaInfoDescription(value) {
      this.metaInfoDataNew.meta_info_description = value;
    },
    handleMetaInfoKeyword(value) {
      this.metaInfoDataNew.meta_info_keyword = value;
    },
    handleMetaInfoPublishDate(value) {
      this.metaInfoDataNew.publish_date = value;
    },
    handleMetaInfoPhotoUrl(value) {
      const file = value[0];
      this.url = URL.createObjectURL(file);
      this.metaInfoDataNew.attachment_meta_info_photo_url = file;
    },
    async updateMetaInfo() {
      if(this.metaInfoDataNew.meta_info_page){
        const check_value = document.getElementById('meta_info_page').value;
        const returnValue = await this.checkDuplicate(check_value);
        if(!returnValue){
          return;
        }
      }

      if(this.metaInfoDataNew.attachment_meta_info_photo_url){
        if (this.metaInfoDataNew.attachment_meta_info_photo_url["size"] > 250000) {
          this.imageError = `The image.`;

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Picture too big. Please upload below 250KB",
          });
          return;
        }
      }

      if(this.metaInfoDataNew.publish_date){
        if(moment(this.metaInfoDataNew.publish_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')){
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Publish Date tidak bisa lebih besar daripada hari ini.",
          });
          return;
        }
      }else{
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Publish Date tidak bisa kosong.",
        });
        return;
      }

      var today = new Date();
      var time = ` ${today.getHours()}:${today.getMinutes()}`;
      var publishDate = this.metaInfoDataNew.publish_date?moment(this.metaInfoDataNew.publish_date + time).format():'';
      let MetaInfoID = this.$route.params.id;
      let formData = new FormData();
      formData.append("meta_info_page", this.metaInfoDataNew.meta_info_page);
      formData.append("meta_info_title", this.metaInfoDataNew.meta_info_title);
      formData.append("meta_info_description", this.metaInfoDataNew.meta_info_description);
      formData.append("meta_info_keyword", this.metaInfoDataNew.meta_info_keyword);
      formData.append("meta_info_publish_time", publishDate);
      if(this.metaInfoDataNew.attachment_meta_info_photo_url){
        formData.append(
            "attachment_meta_info_photo_url",
            this.metaInfoDataNew.attachment_meta_info_photo_url
        );
      }

      axios
          .put(
              `${this.domain}/v1/meta_info/update/${MetaInfoID}`,
              formData,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Meta Info Data Updated`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.items = response.data;
            this.$router.push({ path: `/management/meta-info` });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response?err.response.data.message.id:'Something Went Wrong'
            });
          });
    },
    validator(val) {
      return val ? val.length >= 4 : false;
    },
    async checkDuplicate(val) {
      const getReturnValue = await axios
          .get(
              `${this.domain}/v1/meta_info/page/${val.replace(/\//g,'_')}`,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          )
          .then((response) => {
            const data = response.data;
            if(data.meta_info_page === val && data.meta_info_id != this.metaInfoDataNew.meta_info_id){
              this.metaInfoDataNew.meta_info_page = '';
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: 'Meta Page sudah terpakai.'
              });
              return false;
            }else{
              this.metaInfoDataNew.meta_info_page = val.toLowerCase();
              return true;
            }
          })
          .catch(() => {
            this.metaInfoDataNew.meta_info_page = val.toLowerCase();
            return true;
          });
      return getReturnValue;
    },
  },
};
</script>

<style scoped>
@import "./MetaInfo.css";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
